// extracted by mini-css-extract-plugin
export var accImg = "Inclusion-module--accImg--+OcFx";
export var accordionBg = "Inclusion-module--accordionBg--KmR2D";
export var accordionBody = "Inclusion-module--accordionBody--frUHQ";
export var accordionBtn = "Inclusion-module--accordionBtn--xXHxN";
export var accordionItem = "Inclusion-module--accordionItem--lNJkx";
export var accordionTitle = "Inclusion-module--accordionTitle--wWct5";
export var collapsed = "Inclusion-module--collapsed--sI-Sx";
export var content = "Inclusion-module--content--qEP4Z";
export var darkHr = "Inclusion-module--darkHr--0u1NW";
export var extraRead = "Inclusion-module--extraRead--kxnws";
export var indexCs = "Inclusion-module--indexCs--Fox5e";
export var marginCo = "Inclusion-module--marginCo--GulDJ";
export var noMargin = "Inclusion-module--noMargin--YDtRL";
export var noPadding = "Inclusion-module--noPadding--7wNIs";
export var paddingBo = "Inclusion-module--paddingBo--g-8Q+";
export var paddingCo = "Inclusion-module--paddingCo--bEO9s";
export var readContent = "Inclusion-module--readContent--d5cL6";
export var readText = "Inclusion-module--readText--PR3iB";
export var readText1 = "Inclusion-module--readText1--86kDK";